import React from "react";
import Select, {
    Creatable as SelectCreatable,
    AsyncCreatable as SelectAsyncCreatable,
    ReactSelectProps,
    ReactCreatableSelectProps,
    ReactAsyncSelectProps,
    ReactAsyncCreatableSelectProps,
    Async as SelectAsync,
} from "react-select";
import { FormField } from "./";
import { ValidatedFormFieldBase } from "../validation";

interface OwnProps {
    css?: string;
    id?: string;
    isAsync?: boolean;
    isCreatable?: boolean;
    label?: string;
    select: ReactAsyncSelectProps | ReactSelectProps | ReactCreatableSelectProps | ReactAsyncCreatableSelectProps;
}

export class SelectField extends ValidatedFormFieldBase<OwnProps, {}> {

    public handleChange = (value: any) => {
        this.props.formComponent.setFieldValue(this.props.name, value);

        if (this.props.onInputChange)
            this.props.onInputChange(this.props.name, value);
    }

    public render() {
        const value = this.getValue(true);
        const label = this.getLabel(this.props.label);

        const selectProps: ReactAsyncSelectProps | ReactSelectProps | ReactCreatableSelectProps | ReactAsyncCreatableSelectProps = {
            filterOptions: (options, filter, currentValues) => { // by default no filtering of options. override in custom implementation.
                return options;
            },
            ...this.props.select,
            name: this.props.name,
            value,
            onBlur: () => this.props.formComponent.triggerBlur(this.props.name),
            onChange: (selectedValue: any) => this.handleChange(selectedValue),
        };

        let selectEl = <Select {...selectProps} />;
        if (this.props.isAsync) {
            if (this.props.isCreatable)
                selectEl = <SelectAsyncCreatable {...selectProps as any} />;
            else
                selectEl = <SelectAsync {...selectProps as any} />;
        }
        else if (this.props.isCreatable)
            selectEl = <SelectCreatable {...selectProps as any} />;

        return <FormField {...this.props} errors={this.getErrors()} label={label} name={this.props.name} required={this.isRequired(this.props.required)}>
            {selectEl}
            {this.props.children}
        </FormField>;
    }
}



// WEBPACK FOOTER //
// ./src/components/editors/SelectField.tsx